<template>
  <!-- لیست کشویی مرکز هزینه -->
  <div class="divFilter">
    <div class="table-respon" style="max-height: 140px; overflow-y: auto">
      <table class="table table-bordered table-sm text-center table-font-size">
        <!-- سربرگ جدول -->
        <thead class="bg-primary-light sticky-top">
          <td>ردیف</td>
          <td>کد</td>
          <td>عنوان ({{ TbDataFilter.length }} مورد)</td>
        </thead>
        <tbody>
          <tr
            v-for="row in getListDataPaging"
            :key="row.NCode"
            v-on:click="selectRow(row.NCode, row.SDesc, row.NAccType)"
            v-on:dblclick="dblClickRow(row.NCode, row.SDesc, row.NAccType)"
            v-bind:id="'rowFilter-' + row.NCode"
            :class="{ selRow: selectRowID == row.NCode }"
            style="cursor: pointer;"
          >
            <td>{{ row.RowID }}</td>
            <td>{{ row.NCode }}</td>
            <td
              style="max-width: 200px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;"
              :title="row.SDesc"
            >{{ row.SDesc }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row h12 text-secondary mt-2 d-flex justify-content-center align-items-center">
      <div class="col-9 text-right">
        راهنما : فلش <i class="fas fa-long-arrow-alt-up px-1"></i> و <i class="fas fa-long-arrow-alt-down px-1"></i> حرکت بین سطرها ، F4/Enter انتخاب
      </div>
      <div class="col-3">
        <PaginationSmallBaseUsePlace
          v-bind:Name="'PaginationSmallBaseUsePlace'" 
          v-bind:CountRow="intCountRow"
          v-bind:DataRepository="TbDataFilter" 
          v-on:ChangePage="ChangePage"
        ></PaginationSmallBaseUsePlace>
      </div>
    </div>
  </div>
</template>

<script>
import { BusEvent } from "../../../../../main.js";
import PaginationSmallBaseUsePlace from "../../PublicComponents/PaginationSmall.vue"

export default {
  name: "FilterBaseUsePlace",
  components:{
    PaginationSmallBaseUsePlace
  },
  data() {
    return {
      // مخزن اصلی اطلاعات
      TbData: [],
      // چیزی که دیده می شود
      TbDataFilter: [],
      // اطلاعات سطر در حال انتخاب
      selectRowID: 0,
      selectRowType: 0,
      selectRowSDesc: "",

      // مربوط به صفحه بندی
      intPageNumber: 1,  // شماره صفحه در حال انتخاب
      intCountRow: 100,   // تعداد سطرها در هر صفحه
      intCountPage: 1,   // تعداد کل صفحه ها
      intCountRowShow: 1, // تعداد سطرهای مشاهده شده در صفحه - ممکن است صفحه 200 سطر کامل نباشد

    };
  },
  props: ['FilterCode','RandomNumberChild'],
  watch: {
    FilterCode: function (value) {
      this.filterTbData(value);
    },
    RandomNumberChild: function (value) {
      this.filterTbData(this.FilterCode);
    },
  },
  computed: {
    // نمایش اطلاعات با قابلیت صفحه بندی
    getListDataPaging() {
      if (this.TbDataFilter.length > 0) {
        // شماره شروع رکورد
        let startRowIndex = this.intPageNumber == 1 ? 1 : (parseInt(this.intCountRow) * (parseInt(this.intPageNumber) - 1) + 1);
        let intCountRowLocal = this.intCountRow;
        // انتخاب رکوردهای صفحه مورد نظر
        let ListTemplate = [];
        ListTemplate = this.TbDataFilter.filter(function (item) {
          return (item.RowID >= startRowIndex && item.RowID < (parseInt(startRowIndex) + parseInt(intCountRowLocal)))
        });
        // خروجی لیست صفحه مورد نظر
        return ListTemplate;
      } else {
        return [];
      }
    },
  },
  methods: {
    // رویداد تغییر صفحه از کامپاننت صفحه بندی
    ChangePage(value) {
      this.intPageNumber = value.pageNumber;
      this.intCountRow = value.countRow;
      this.intCountPage = value.countPage;
    },
    getTbData() {
      this.TbData = this.$store.getters.getTbBaseUsePlaceData;
      this.TbDataFilter = this.TbData;
    },

    async filterTbData(NCode) {

      if(NCode != 0 && NCode != ''){
        this.TbDataFilter = this.TbData.filter(function (t) {
          return t.NCode.toString().startsWith(NCode);
        });
        // درج شماره ردیف برای لیست
        this.TbDataFilter = await this.$store.dispatch('setRowIDForList', this.TbDataFilter);
      } else {
        this.TbDataFilter = this.TbData;
      }
    },

    dblClickRow(NCode, SDesc, NAccType) {
      this.selectRow(NCode, SDesc, NAccType);
      this.SelectHesab();
    },

    selectRow(NCode, SDesc, NAccType) {
      this.selectRowID = NCode;
      this.selectRowSDesc = SDesc;
      this.selectRowType = NAccType;
    },

    SelectHesab() {
      if (this.selectRowID == 0) {
        this.$store.dispatch(
          "notify",
          "سطری در حالت انتخاب نیست !\nلطفا ابتدا یکی از سطرها را در حالت انتخاب قرار دهید ."
        );
      } else {
        this.$emit("HideFilter", {
          NCode: this.selectRowID,
          SDesc: this.selectRowSDesc,
          NAccType: this.selectRowType,
        });
      }
    },

    // تابع مدیریت کلید میانبرها داخل سند
    hotKeyChecker(keyvalue) {
      //alert('filter hesab : ' + keyvalue.key);
      if (this.TbDataFilter.length > 0) {
        if (keyvalue.key === "ArrowUp" || keyvalue.key === "ArrowDown") {
          let index = this.TbDataFilter.findIndex(
            (itme) => itme.NCode == this.selectRowID
          );
          if (index != -1) {
            if (keyvalue.key === "ArrowUp") {
              if (index > 0) {
                this.selectRow(
                  this.TbDataFilter[index - 1].NCode,
                  this.TbDataFilter[index - 1].SDesc,
                  this.TbDataFilter[index - 1].NAccType
                );
                $(
                  "#rowFilter-" + this.TbDataFilter[index - 1].NCode
                ).scrollintoview({
                  duration: 100,
                  //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
                });
              }
            } else {
              if (index + 1 < this.TbDataFilter.length) {
                this.selectRow(
                  this.TbDataFilter[index + 1].NCode,
                  this.TbDataFilter[index + 1].SDesc,
                  this.TbDataFilter[index + 1].NAccType
                );
                $(
                  "#rowFilter-" + this.TbDataFilter[index + 1].NCode
                ).scrollintoview({
                  duration: 100,
                  //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
                });
              }
            }
          } else {
            this.selectRow(
              this.TbDataFilter[0].NCode,
              this.TbDataFilter[0].SDesc,
              this.TbDataFilter[0].NAccType
            );
          }
        }
        // انتخاب سطر و بستن پنجره
        if (keyvalue.key === "F4" || keyvalue.key === "Enter") {
          this.SelectHesab();
        }
      }
    },
  },
  created() {
    //alert('create Filter');
    this.getTbData();
    BusEvent.$on("keyPressValue", this.hotKeyChecker);
  },
  beforeDestroy() {
    //alert('Destroy Filter');
    BusEvent.$off("keyPressValue", this.hotKeyChecker);
  },
};
</script>

<style scoped>
.divFilter {
  position: absolute;
  background-color: #fee3e8;
  width: 370px;
  min-height: 80px;
  /* max-height: 170px; */
  margin-top: 35px;
  z-index: 99999;
  /* top: 52px; */
  padding: 5px;
  border-radius: 5px;
  box-shadow: rgb(0 0 0 / 40%) 0px 0px 5px;
}

.divFilter table {
  background-color: white;
}

.selRow {
  background-color: #fbff94;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/NewAccDoc/Components/FilterBaseUsePlace.vue